import httpManager from "@/app/shared/utils/httpManager";

export default async function (portfolioId) {
  const response = await httpManager.getBlob(
    `/portfolios/${portfolioId}/dashboard/download-excel/`
  );
  return response;
}
